import React from 'react';
import Modal from '@components/common/modal';
import Button from '@components/common/button';

import Icon from '@components/common/assets';
import classnames from 'classnames/bind';
import styles from './leaveModal.module.scss';
const cx = classnames.bind(styles);

interface Props {
  visible: boolean;
  onClose: () => void;
  onOk: () => void;
}

const LeaveModal = ({ visible, onClose, onOk }: Props) => {
  return (
    <Modal visible={visible}>
      <div className={cx('leaveModal')}>
        <Icon name="errorYellowFill" width={64} height={64} />
        <h3 className={cx('leaveModalTitle')}>페이지를 나가시겠습니까?</h3>
        <p className={cx('leaveModalDesc')}>작성 중인 추가 정보는 저장되지 않습니다.</p>
        <div className={cx('buttons')}>
          <Button className={cx('button')} onClick={onClose} theme="secondary">
            취소
          </Button>
          <Button className={cx('button')} onClick={onOk}>
            나가기
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LeaveModal;
